import { useInfiniteQuery } from '@tanstack/react-query';

import { SUGGESTED_FOR_YOU_LIMIT } from '@/app/[locale]/(home)/components/SuggestedForYou/constants';
import { userRecommendationsFeedInfiniteQueryOptions } from '@/modules/explore/queries';
import { getObjectsFromPages } from '@/modules/pagination/getObjectsFromPages';
import { toLegacySavedProduct } from '@/modules/product/migration/toLegacySavedProduct';
import { type SearchListProduct } from '@/modules/product/types';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useSuggestedForYouProducts() {
  const [, user] = useCurrentUser();

  const queryResult = useInfiniteQuery(
    userRecommendationsFeedInfiniteQueryOptions({
      include_like_count: true,
      limit: SUGGESTED_FOR_YOU_LIMIT,
      userId: user?.id,
    })
  );

  return {
    ...queryResult,
    data: getObjectsFromPages(queryResult.data).map<SearchListProduct>(
      toLegacySavedProduct
    ),
  };
}
